import { useMemo } from "react";
import { useSplitClient } from "@splitsoftware/splitio-react";
import { useStore } from "effector-react";

import { $serviceLocation } from "../store";

import { featureFlagNames } from "@hunkware/common";

export type FlagKey = (typeof featureFlagNames)[number];

type Flags = {
  [key in FlagKey]: string;
};

type Toggles = {
  [key in FlagKey]: boolean;
};

export const useFeatureFlagsWithAttributes = () => {
  const { location } = useStore($serviceLocation);

  const { client } = useSplitClient();

  const { flags, toggles } = useMemo(() => {
    const attributes: SplitIO.Attributes = {};

    if (location?.id) {
      attributes.location_id = location.id;
      attributes.location_name = location.name;
      attributes.location_timezone_name = location?.timeZone?.name;
    }

    return featureFlagNames.reduce<{
      flags: Flags;
      toggles: Toggles;
    }>(
      (obj, key) => {
        const value = client?.getTreatment(key, attributes);

        return {
          flags: { ...obj.flags, [key]: value },
          toggles: { ...obj.toggles, [key]: value === "on" },
        };
      },
      { flags: {} as Flags, toggles: {} as Toggles },
    );
  }, [client, location?.id, location?.name, location?.timeZone?.name]);

  return { flags, toggles };
};
